import { Injectable } from '@angular/core';

export enum BrowserWindowType {
  FRAME = 'FRAME',
  POPUP = 'POPUP',
  TOP = 'TOP',
  UNKNOWN = 'UNKNOWN'
}

@Injectable()
export class BrowserWindowService {

  constructor(private reference: Window) {
    if (this.reference) {
      this.type = this.reference.opener ?
                  BrowserWindowType.POPUP :
                  this.reference.self === this.reference.top ?
                  BrowserWindowType.TOP :
                  BrowserWindowType.FRAME;
    }
  }

  public type: BrowserWindowType = BrowserWindowType.UNKNOWN;

  public close(): void {
    if (this.type === BrowserWindowType.POPUP &&
        typeof this.reference.close === 'function') {
        this.reference.close();
    }
  }

}
